export default __webpack_public_path__ + "static/media/slide_05.752e0c5a.png";